import React from 'react';
import Form from 'react-bootstrap/Form';



function MissingLastNameForm (props) {
    return (
        <Form.Group id = "createLastNameGroupSocial"  className= "relative">
                <Form.Label className = {`${props.floatLastName === true ? "absolute floating-label" : "absolute inline-label" }
                                        ${props.lastNameFocus === true ? "label-black__TO" : "" }
                                        ${props.isLastNameValid === false && props.lastNameFocus === false ? "label-red__TO" : ""}
                `} >
                    Last Name<span id="redStar">*</span></Form.Label>
                <Form.Control
                required
                id = "createLastName__TO"
                data-testid = "createLastName"
                aria-label = "Last Name"
                as = "input"
                type = "text"
                name = "lastname"
                value = {props.lastName}
                onChange = {props.handleLastNameChange}
                onFocus = {props.setFocusLastName}
                onBlur = {props.onBlurLastName}
                bsPrefix = {`${props.isLastNameValid === false && props.lastNameFocus === false ? "highlight-error__TO form-control" : ""}`}

            />
            <div
                id = "createLastNameAlert" 
                data-testid = "createLastNameError" 
                className = {`logon-item-error__TO ${props.isLastNameValid === false && props.lastNameFocus == false ? "block" : "none"}`}
                role = "alert" 
                aria-hidden = {`${props.isLastNameValid === false && props.lastNameFocus === false ? "false" : "true"}`}
            >
                Your last name must be between 1 and 29 characters. It can include spaces, apostrophes, and hyphens.
            </div>
        </Form.Group>
    )
}

export default MissingLastNameForm;